import { render, staticRenderFns } from "./StaffImageModal.vue?vue&type=template&id=e0755c30"
import script from "./StaffImageModal.vue?vue&type=script&lang=js"
export * from "./StaffImageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports